module.exports = __webpack_public_path__ + "static/media/signlock.d4664a46.svg";